// src/api/cart.api.js
import api from "./axiosClient";

export const cartAPI = {
  /**
   * Get current user's cart
   */
  async getCart() {
    const response = await api.get("/cart/");
    return response.data;
  },

  /**
   * Add item to cart
   * Backend handles duplicate detection and quantity aggregation
   */
  async addItem(data) {
    const response = await api.post("/cart/items", data);
    return response.data;
  },

  /**
   * Update item quantity
   */
  async updateQuantity(productId, quantity) {
    const response = await api.patch(
      `/cart/items/${productId}`,
      { quantity }
    );
    return response.data;
  },

  /**
   * Remove item from cart
   */
  async removeItem(productId) {
    const response = await api.delete(`/cart/items/${productId}`);
    return response.data;
  },

  /**
   * Clear entire cart
   */
  async clearCart() {
    const response = await api.delete("/cart/");
    return response.data;
  },

  /**
   * Merge guest cart into user cart on login
   * Backend expects ARRAY, not wrapped object
   */
  async mergeGuestCart(guestItems) {
    const response = await api.post("/cart/merge", guestItems);
    return response.data;
  },

  /**
   * FIX-15: Validate cart items before checkout.
   * Returns { valid: bool, invalid_items: [...], price_changes: [...] }
   * Call before order creation to catch stale inventory and price changes.
   */
  async validate() {
    const response = await api.get("/cart/validate");  // backend uses GET (read-only)
    return response.data;
  },

  // ── Coupon methods ────────────────────────────────────────────────────────

  /**
   * Apply a coupon code to the cart.
   * Returns { valid, coupon_code, discount_amount, cart_subtotal,
   *           final_total, reason, message }
   * Always returns 200 — check `valid` field to determine success.
   */
  async applyCoupon(couponCode) {
    const response = await api.post("/cart/apply-coupon", {
      coupon_code: couponCode,
    });
    return response.data;
  },

  /**
   * Remove the currently applied coupon from the cart.
   * Idempotent — returns 200 even if no coupon was applied.
   */
  async removeCoupon() {
    const response = await api.delete("/cart/remove-coupon");
    return response.data;
  },

  /**
   * Get current cart coupon state (for page restore on load).
   * Returns { coupon_code, discount_amount, applied_at, is_stale }
   */
  async getCouponStatus() {
    const response = await api.get("/cart/coupon-status");
    return response.data;
  },

  /**
   * Get publicly available coupons the current user is eligible for.
   * Used for the "Available Offers" panel on the cart page.
   */
  async getPublicCoupons(limit = 10) {
    const response = await api.get("/coupons/public", { params: { limit } });
    return response.data;
  },
};